/** Letswebinar public front. Titles match core/product_fronts.py. */

export const HERO = {
  eyebrow: 'Webinars for your organisation',
  headline: 'Host the session',
  accent: 'on Letswebinar',
  lead: 'Schedule it, let guests join from a link, and keep the chat, questions and attendance with the event.',
};

export const BULLETS = [
  'Scheduled, anytime and scrollable webinars',
  'Guests join without an account',
  'Chat, questions and the media library stay on the event',
];

export const PREVIEW = {
  title: 'A sample session',
  rows: [
    ['Schedule', 'Weekly'],
    ['Room', 'Chat on'],
    ['Guests', 'Join link'],
    ['After', 'Attendance'],
  ],
};

export const STEPS = [
  ['Build the event', 'Name, length, video and schedule are one wizard.'],
  ['Send the link', 'Guests register with name, email and phone. Reminders go out before the session.'],
  ['Read the room', 'Analytics and the chat report stay attached to that webinar.'],
];

export const GROUPS = [
  {
    id: 'event',
    title: 'The event',
    intro: 'How a webinar is set up before anyone arrives.',
    features: [
      ['Event wizard', 'Set the name, length, video and schedule in one flow.'],
      ['Repeating sessions', 'Daily, weekly or monthly, with a time and a timezone.'],
      ['Anytime webinars', 'Guests can start when they arrive, and can start over when you allow it.'],
      ['Scrollable webinars', 'The guest moves through the video instead of waiting on a clock.'],
    ],
  },
  {
    id: 'room',
    title: 'In the room',
    intro: 'What plays, and what people can say, during the session.',
    features: [
      ['Video source', 'A link, an uploaded file, or a video from the media library.'],
      ['Playback', 'Uploaded video can be prepared for streaming playback.'],
      ['Live chat', 'Turn chat on for the session. The transcript stays with the webinar.'],
      ['Audience questions', 'Guests ask from the room. Answers can be scripted onto a clock.'],
      ['Ghost attendees', 'Named stand-ins, added one by one or from a spreadsheet, with timed questions.'],
    ],
  },
  {
    id: 'guests',
    title: 'Guests and reminders',
    intro: 'How people get in, and how they are reminded.',
    features: [
      ['Join link', 'Guests register with name, email and phone. They do not need an account.'],
      ['Registration tags', 'Source, campaign, medium and your own labels travel with the guest.'],
      ['Email and text reminders', 'Two days, one day, and three hours before a session.'],
      ['Organisation users', 'Admins manage the people who run events.'],
    ],
  },
  {
    id: 'after',
    title: 'After the session',
    intro: 'What you can still see once the room closes.',
    features: [
      ['Session analytics', 'Sessions and registrants, with filters and an Excel download.'],
      ['Chat report', 'The conversation from the room, for that webinar.'],
      ['Media library', 'Keep files on the server, in your S3 bucket, or both.'],
      ['Per-event page', 'A title, description and image for that webinar.'],
    ],
  },
];
